import {
  ExportToGoogleSheetsContext,
  ExportToGoogleSheetsSchemaType,
  ExportToGoogleSheetsCardShared,
  EXPORT_TO_GOOGLE_SHEETS,
} from '@scale/compass-shared/cards/export_to_google_sheets';
import { CompassCardUI } from '@scale/compass-ui/types';
import { faTableCells } from '@fortawesome/pro-solid-svg-icons';
import ExportToGoogleSheetCardComponent from './ExportToGoogleSheetCardComponent';

const DefaultExportToGoogleSheetsContext: ExportToGoogleSheetsContext = {
  cardType: EXPORT_TO_GOOGLE_SHEETS,
  sheetURL: '',
  exportStrategy: 'dynamic',
  exportToSheet: '',
};

export const ExportToGoogleSheetsCardInfo: CompassCardUI<ExportToGoogleSheetsSchemaType> = {
  ...ExportToGoogleSheetsCardShared,
  title: 'Export to Google Sheets',
  icon: 'table-cells',
  toolTip: 'Export your data to different tabs in a Google Sheets.',
  defaultContext: DefaultExportToGoogleSheetsContext,
  showOutput: true,
  legacyComponent: ExportToGoogleSheetCardComponent,
  button: {
    icon: faTableCells,
  },
};
